document.addEventListener('DOMContentLoaded', function() {
  function initCopyCoupon() {
    const btn = document.getElementById('copyCouponBtn');
    if (!btn) return;

    const coupon = btn.getAttribute('data-coupon') || '';
    const textEl = document.getElementById('copyCouponText');

    btn.addEventListener('click', function() {
      if (!coupon) return;

      function done() {
        if (textEl) textEl.textContent = 'Copiado!';
        btn.classList.add('copied');

        setTimeout(function() {
          if (textEl) textEl.textContent = 'Copiar cupom';
          btn.classList.remove('copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(coupon).then(done).catch(function() {
          fallbackCopy(coupon, done);
        });
      } else {
        fallbackCopy(coupon, done);
      }
    });
  }

  function fallbackCopy(code, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();

    try {
      if (document.execCommand('copy')) onSuccess();
    } catch (e) {}

    document.body.removeChild(ta);
  }

  function showRewardPanel() {

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    var quiz = document.getElementById('cardsQuizForm');
    var panel = document.getElementById('cardsRewardPanel');

    if (quiz) quiz.classList.add('hidden');
    if (panel) panel.classList.remove('hidden');

    initCopyCoupon();
  }

  initCopyCoupon();

  if (window.cardsFormSuccess) {
    showRewardPanel();
  }
});
